import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useMemo, useCallback, useState, useEffect, Fragment } from 'react';
import { useSelect } from 'downshift';
import '../FormControl/FormControl.es.js';
import { useFormControl } from '../FormControl/FormControlContext.es.js';
import { List } from '../List/List.es.js';
import { Scrollable } from '../Scrollable/Scrollable.es.js';
import { Input } from '../Input/Input.es.js';
import { PopoverBase } from '../PopoverBase/PopoverBase.es.js';
import 'use-callback-ref';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { forwardRef } from '../../system/forwardRef.es.js';
import { omitSystemProps, getSystemProps } from '../../system/styled-system.es.js';
import { getGroups, getOptionsByGroup } from './utils.es.js';
import { SelectInputComponent } from './SelectInputComponent.es.js';
import { DefaultOptionComponent } from './DefaultOptionComponent.es.js';
import { DefaultValueComponent } from './DefaultValueComponent.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

function isValueDefined(value) {
  return typeof value !== "undefined";
}

var Select = forwardRef(function (props, ref) {
  var _a = omitSystemProps(props),
      options = _a.options,
      _a$shape = _a.shape,
      shape = _a$shape === void 0 ? "default" : _a$shape,
      _a$size = _a.size,
      size = _a$size === void 0 ? "md" : _a$size,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? "outlined" : _a$variant,
      isInvalid = _a.isInvalid,
      isValid = _a.isValid,
      isRequired = _a.isRequired,
      isDisabled = _a.isDisabled,
      isReadOnly = _a.isReadOnly,
      defaultValue = _a.defaultValue,
      placeholder = _a.placeholder,
      groupBy = _a.groupBy,
      onChange = _a.onChange,
      _a$valueComponent = _a.valueComponent,
      ValueComponent = _a$valueComponent === void 0 ? DefaultValueComponent : _a$valueComponent,
      _a$optionComponent = _a.optionComponent,
      OptionComponent = _a$optionComponent === void 0 ? DefaultOptionComponent : _a$optionComponent,
      popoverProps = _a.popoverProps,
      disablePortal = _a.disablePortal,
      _a$usePortal = _a.usePortal,
      usePortal = _a$usePortal === void 0 ? false : _a$usePortal,
      value = _a.value,
      rest = __objRest(_a, ["options", "shape", "size", "variant", "isInvalid", "isValid", "isRequired", "isDisabled", "isReadOnly", "defaultValue", "placeholder", "groupBy", "onChange", "valueComponent", "optionComponent", "popoverProps", "disablePortal", "usePortal", "value"]);

  var _b = getSystemProps(props),
      color = _b.color,
      _b$width = _b.width,
      width = _b$width === void 0 ? "100%" : _b$width,
      systemProps = __objRest(_b, ["color", "width"]);

  var anchorRef = useRef(null);
  var menuRef = useRef(null);
  var formControl = useFormControl({
    isInvalid: isInvalid,
    isValid: isValid,
    isRequired: isRequired,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly
  });
  var groups = useMemo(function () {
    return getGroups(groupBy, options);
  }, [options, groupBy]);
  var optionsWithIndexes = useMemo(function () {
    return options.map(function (item, index) {
      return __spreadProps(__spreadValues({}, item), {
        index: index
      });
    });
  }, [options]);
  var groupedOptions = useMemo(function () {
    return getOptionsByGroup(groupBy, groups, optionsWithIndexes);
  }, [groupBy, groups, optionsWithIndexes]);
  var getSelectedItemFromValue = useCallback(function (value2) {
    return optionsWithIndexes.find(function (option) {
      return option.value === value2;
    }) || null;
  }, [optionsWithIndexes]);
  var updateToDefaultItem = useCallback(function () {
    var defaultSelectedItem = getSelectedItemFromValue(defaultValue);
    setSelectedItem(defaultSelectedItem);

    if (onChange && defaultSelectedItem) {
      onChange(defaultSelectedItem);
    }
  }, [defaultValue, getSelectedItemFromValue, onChange]);

  var _useState = useState(function () {
    if (isValueDefined(value)) {
      return null;
    }

    return getSelectedItemFromValue(defaultValue);
  }),
      selectedItem = _useState[0],
      setSelectedItem = _useState[1];

  useEffect(function () {
    if (isValueDefined(value)) {
      var newSelectedItem = getSelectedItemFromValue(value);

      if (!newSelectedItem || !newSelectedItem.disabled) {
        setSelectedItem(newSelectedItem);
      } else {
        updateToDefaultItem();
      }
    }
  }, [value, getSelectedItemFromValue, updateToDefaultItem]);

  var _useSelect = useSelect({
    items: optionsWithIndexes,
    selectedItem: selectedItem,
    onSelectedItemChange: function onSelectedItemChange(_ref) {
      var selectedItem2 = _ref.selectedItem;

      if (!selectedItem2) {
        return;
      }

      setSelectedItem(selectedItem2);

      if (onChange) {
        onChange(selectedItem2);
      }
    }
  }),
      isOpen = _useSelect.isOpen,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getMenuProps = _useSelect.getMenuProps,
      getItemProps = _useSelect.getItemProps,
      highlightedIndex = _useSelect.highlightedIndex;

  var _useState2 = useState(),
      anchorWidth = _useState2[0],
      setAnchorWidth = _useState2[1];

  useEffect(function () {
    if (!selectedItem) {
      return;
    }

    var newSelectedItemByIndex = optionsWithIndexes[selectedItem.index];
    var newSelectedItemByValue = getSelectedItemFromValue(value);

    if (isValueDefined(value) && newSelectedItemByIndex !== newSelectedItemByValue) {
      return;
    }

    if (newSelectedItemByIndex !== selectedItem) {
      var selectedItemByValue = getSelectedItemFromValue(selectedItem.value);

      if (!!selectedItemByValue && !(selectedItemByValue == null ? void 0 : selectedItemByValue.disabled)) {
        setSelectedItem(selectedItemByValue);
      } else {
        updateToDefaultItem();
      }
    }
  }, [optionsWithIndexes, selectedItem, value, updateToDefaultItem, getSelectedItemFromValue]);
  useEffect(function () {
    if (!anchorRef.current) {
      return;
    }

    var currentSelectWidth = anchorRef.current.clientWidth;
    setAnchorWidth(currentSelectWidth);
  }, [isOpen]);
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(Input, __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({
      ref: ref,
      wrapperRef: anchorRef,
      shape: shape,
      size: size,
      variant: variant,
      isInvalid: formControl.isInvalid,
      isDisabled: formControl.isDisabled,
      isReadOnly: formControl.isReadOnly,
      isRequired: formControl.isRequired
    }, getToggleButtonProps()), rest), {
      width: width
    }), systemProps), {
      as: SelectInputComponent
    }), selectedItem ?
    /* @__PURE__ */
    React.createElement(ValueComponent, {
      selectedItem: selectedItem
    }) : placeholder),
    /* @__PURE__ */
    React.createElement(PopoverBase, __spreadProps(__spreadValues({
      minWidth: anchorWidth,
      anchorRef: anchorRef,
      isOpen: !isDisabled && isOpen
    }, popoverProps), {
      offset: [0, 4],
      placement: "bottom",
      px: 0,
      py: 0,
      disablePortal: disablePortal,
      usePortal: usePortal
    }),
    /* @__PURE__ */
    React.createElement(Scrollable, null,
    /* @__PURE__ */
    React.createElement(List, __spreadValues({}, getMenuProps({
      ref: menuRef
    }, {
      suppressRefError: true
    })), groupedOptions.map(function (groupData, index) {
      return (
        /* @__PURE__ */
        React.createElement(Fragment, {
          key: index
        }, groupData.group &&
        /* @__PURE__ */
        React.createElement(List.Subheader, null, groupData.group), groupData.options.map(function (option) {
          return (
            /* @__PURE__ */
            React.createElement(List.Item, __spreadValues({
              key: option.index,
              isSelected: option.index === highlightedIndex,
              disabled: option.disabled
            }, getItemProps({
              item: option,
              index: option.index
            })),
            /* @__PURE__ */
            React.createElement(OptionComponent, {
              option: option
            }))
          );
        }))
      );
    })))))
  );
});
Select.displayName = "Select";
var Select$1 = Object.assign(Select, {});
export { Select$1 as default };